jQuery.noConflict();

jQuery(document).ready(function(){
	
	jQuery('.checkboxesForTax').each(function(){
		jQuery(this).hide();
	});
	
		jQuery('div.checkboxesForTax div label').on('keypress', function(event2){	
				if (getEvent(event2) === true) {
					
					jQuery(this).siblings("input").trigger('click');
				}
			})
	
		jQuery('div.checkboxsThatAreRadio label').on('keypress', function(event3){	
				
				if (getEvent(event3) === true) {
					
					jQuery(this).siblings("input").trigger('click');
				}
			})
	

	
	jQuery('div.taxTitle').on('click keypress', function(event){
	
	if (getEvent(event) === true) {

		if (jQuery(this).next('.checkboxesForTax').is(':visible')){
			jQuery(this).next('.checkboxesForTax').hide('slow');
			jQuery(this).parent('.termbox').css('background-color','#fff');
			
			if (jQuery(this).hasClass('upArrow')){
				jQuery(this).addClass('downArrow');
				jQuery(this).removeClass('upArrow');
				jQuery(this).find('span[role]').css('font-weight', '400');
				jQuery(this).find('span[role]').attr('aria-expanded', 'false');
				jQuery(this).find('span.count').css('font-weight', '400');
				
			}else {
				jQuery(this).addClass('upArrow');
				jQuery(this).removeClass('downArrow');
				jQuery(this).find('span[role]').css('font-weight', '700');
				jQuery(this).find('span[role]').attr('aria-expanded', 'true');
				jQuery(this).find('span.count').css('font-weight', '700');
			}
		
		}else {
			jQuery(this).next('.checkboxesForTax').show('slow');
			jQuery(this).parent('.termbox').css('background-color','#f6f6f6');
			
			if (jQuery(this).hasClass('downArrow')) {
				jQuery(this).addClass('upArrow');
				jQuery(this).removeClass('downArrow');
				jQuery(this).find('span[role]').css('font-weight', '700');
				jQuery(this).find('span[role]').attr('aria-expanded', 'true');
				jQuery(this).find('span.count').css('font-weight', '700');
			}else {
				jQuery(this).addClass('downArrow');
				jQuery(this).removeClass('upArrow');
				jQuery(this).find('span[role]').css('font-weight', '400');
				jQuery(this).find('span[role]').attr('aria-expanded', 'false');
				jQuery(this).find('span.count').css('font-weight', '400');
			}
			
		
		}
	}
	})
	
	/* accessibility make sure they are tabable and clickable */
	function getEvent(event) {
		 if(event.type === 'click'){
			return true;
		}
		else if(event.type === 'keypress'){
			var code = event.charCode || event.keyCode;
			if((code === 32)|| (code === 13)){
				return true;
			}
		}
		else{
			return false;
		}
	}

	
	
	
	jQuery('div.checkboxesForTax input[type="checkbox"]').each(function(){
		jQuery(this).on('change', function(){ 
			var getName = (jQuery(this).attr('name'));
			var removeBrakets = getName.split('[');
			
			var Checked = jQuery("input[name^='"+removeBrakets[0]+"']:checked");
			
			var countCheckboxes = jQuery("input[name^='"+removeBrakets[0]+"']:checked").length;
				if (jQuery(this).is(':checked')){
					// find the all checkbox
					jQuery("#"+removeBrakets[0]+"All").prop('checked', false);
				}else{
					
						if(countCheckboxes == 0){
							jQuery("#"+removeBrakets[0]+"All").prop('checked', true);
						}
					}
					
					
				if (jQuery(this).val() == 'All'){
					if (countCheckboxes > 0) {
						
							jQuery("input[name^='"+removeBrakets[0]+"']").not(this).prop('checked', false);
						
						
						jQuery("#"+removeBrakets[0]+"All").prop('checked', true);
					}
					
					
				}					
			})
			
		})
		
		var per_page = jQuery('div.the_results').attr('data-per-page');
		var numberOfPrograms = jQuery('.programItem').length;
		jQuery('div.programItem').each(function(i,k){
			if (i > per_page){
				jQuery(this).hide();
			}
			if (i == per_page){
				jQuery(this).after('<span tabindex="0" role="button" id="allPrograms">Load Remaining Programs</span>');	
			}
			
			
		})
		
		if (numberOfPrograms < per_page){
			if (jQuery('#resultsIdEdAbroad').hasClass('noresultBorder')){
				jQuery('#resultsIdEdAbroad').removeClass('noresultBorder');
			}
			
			jQuery('#resultsIdEdAbroad').addClass('resultBorder');
			
			
		}else {
			if (jQuery('#resultsIdEdAbroad').hasClass('resultBorder')){
				jQuery('#resultsIdEdAbroad').removeClass('resultBorder');
			}
			
			jQuery('#resultsIdEdAbroad').addClass('noresultBorder');
		}
		
		
		jQuery('#allPrograms').on('click keypress', function(e){
			if (getEvent(event) === true) {
				jQuery('div.the_results div.programItem').siblings().show();
				jQuery(this).hide();
				
				if (jQuery('#resultsIdEdAbroad').hasClass('noresultBorder')){
					jQuery('#resultsIdEdAbroad').removeClass('noresultBorder');
				}
				jQuery('#resultsIdEdAbroad').addClass('resultBorder');
			}
		})
		
		
})